import Anchor from 'containers/ac-containers/ac-anchor';
import { useModalContext } from 'hooks/useModalContext';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { IntroductionSection, TeachSection, TrialSection, TriceSection, TutorsSection, TutorsSelectionSection } from './components';
import styles from './styles.scss';

export default function TutorsPage(props: { location: any }) {
	const { setTrigger, setEvent } = useModalContext()
	const anchor = useHistory().location.hash;

	useEffect(() => {
		if (!anchor) {
			window.scrollTo(0, 0);
		}
	}, []);


	function handleClick(eventParam: any) {
		setTrigger(true);
		setEvent({ ...eventParam });
	}

	return (
		<div className={styles['ac-container']}>
			<main className={styles['ac-tutors']}>
				<IntroductionSection />
				<TutorsSelectionSection onClick={() => {
					handleClick({ eventId: '' });
				}} />
				<TeachSection />
				<TriceSection />
				<TutorsSection />
				<TrialSection onClick={() => {
					handleClick({ eventId: '' });
				}} />
				<Anchor className={styles.anchor} anchorText={'introduction'} eventId="PAG_94b2e816f60188a4">
					<img src="https://web-data.zmlearn.com/image/jeHUMoWZJJibHRhSFNC1C1/img_backtop%402x.png" alt="" />
				</Anchor>
			</main>
		</div>
	);
}
